module.exports = __webpack_public_path__ + "img/quest_icon_0014_axe.d49c6389.png";